<template>
    <b-modal
        id="yearbook-settings-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        ok-only
        :ok-title="$t('common.save')"
        ok-variant="primary"
        size="md"
        @ok="onOk"
        :title="$t('magazine.yearbook_settings')">
        <div class="magazine-settings">
            <div class="git-wizard-settings">
                <h3 class="title">{{ $t('magazine.present_wizard') }}</h3>
                <div class="description">
                    {{ $t('magazine.below_you_can_set_a_time_range_for_when_the_gift_wizard_modal_should_be_shown') }}
                </div>
                <div class="start-date-time">
                    <b-form-group
                        class="start-date-group"
                        :label="$t('magazine.start_date')"
                        label-for="yearbook-tanks-modal-start">
                        <template v-slot:label>
                            {{ $t('magazine.start_date') }} <span class="required">*</span></template
                        >
                        <b-form-datepicker
                            class="apprentice-date-picker btn-date-group"
                            id="yearbook-tanks-modal-start"
                            v-model="gift_modal_start[0]"
                            start-weekday="1"
                            now-button
                            reset-button
                            right
                            locale="nl"
                            :aria-controls="$t('magazine.choose_a_date')"
                            label-reset-button="reset"
                            today-variant="primary"
                            nav-button-variant="primary"
                            :label-no-date-selected="$t('magazine.no_date_selected')"
                            menu-class="datedropdown"
                            @input="updateDate($event, 'start')"
                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
                        </b-form-datepicker>
                    </b-form-group>

                    <b-form-group
                        class="start-time-group"
                        :label="$t('magazine.start_time')">
                        <template v-slot:label>
                            {{ $t('magazine.start_time') }} <span class="required">*</span></template
                        >
                        <design-2021-apprentice-timepicker-component v-model="gift_modal_start[1]">
                        </design-2021-apprentice-timepicker-component>
                    </b-form-group>
                </div>

                <div class="end-date-time">
                    <b-form-group
                        class="end-date-group"
                        :label="$t('magazine.end_date')"
                        label-for="yearbook-tanks-modal-end">
                        <template v-slot:label> {{ $t('magazine.end_time') }} <span class="required">*</span></template>
                        <b-form-datepicker
                            class="apprentice-date-picker btn-date-group"
                            id="yearbook-tanks-modal-end"
                            v-model="gift_modal_end[0]"
                            start-weekday="1"
                            now-button
                            reset-button
                            right
                            locale="nl"
                            :aria-controls="$t('magazine.choose_a_date')"
                            label-reset-button="reset"
                            today-variant="primary"
                            nav-button-variant="primary"
                            :label-no-date-selected="$t('magazine.no_date_selected')"
                            menu-class="datedropdown"
                            @input="updateDate($event, 'start')"
                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
                        </b-form-datepicker>
                    </b-form-group>

                    <b-form-group
                        class="end-time-group"
                        :label="$t('magazine.end_time')">
                        <template v-slot:label> {{ $t('magazine.end_time') }} <span class="required">*</span></template>
                        <design-2021-apprentice-timepicker-component
                            v-model="gift_modal_end[1]"></design-2021-apprentice-timepicker-component>
                    </b-form-group>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-magazine-yearbooks-settings-modal-component',
    data() {
        return {
            gift_modal_start: [],
            gift_modal_end: [],
            modal: false,
        };
    },
    methods: {
        updateDate(event, type) {
            if (type === 'start') {
                this.startDate = event;
            } else {
                this.end = event;
            }
        },
        show() {
            this.axios.get(this.routes.yearbookSettings()).then(
                (response) => {
                    this.gift_modal_start = response.data.gift_modal_start.formatted.split(' ');
                    this.gift_modal_end = response.data.gift_modal_end.formatted.split(' ');
                    this.modal = true;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onOk() {
            this.alert.saving();
            const data = {
                gift_modal_start: this.gift_modal_start[0] + ' ' + this.gift_modal_start[1],
                gift_modal_end: this.gift_modal_end[0] + ' ' + this.gift_modal_end[1],
            };

            this.axios.post(this.routes.yearbookSettings(), data).then(
                (response) => {
                    this.alert.success();
                    this.modal = false;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.form-control,
.form-group :deep {
    &,
    .time-picker input {
        margin-bottom: 0;
    }
}

.description {
    font-size: $base-font-size;
    font-weight: $font-weight-medium;
    color: $text-muted-color;
    margin-bottom: $grid-gutter-width;
}

.start-date-time,
.end-date-time {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');
}

.start-date-group,
.end-date-group,
.start-time-group,
.end-time-group {
    flex: 1 0 100%;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .start-date-time {
        margin-bottom: $grid-gutter-width;
    }

    .start-date-time,
    .end-date-time {
        column-gap: $grid-gutter-width;
    }

    .start-date-group,
    .end-date-group {
        flex: 1 0 calc(67% - 30px);
    }

    .start-time-group,
    .end-time-group {
        flex: 1 0 calc(33% - 30px);
    }
}
</style>
